import type { ProductModificationWorkflowError } from 'epic/postTradeOperations/productModification/productModificationResultEpic';
import type { NextWorkflowError } from 'models/NextWorkflowError';
import { connect } from 'react-redux';
import * as ProductModificationSelectors from 'state/productModificationForm/productModificationForm.selector';
import { getIsUserInternal } from 'state/selectors/common/user';
import type { AppState } from 'state/state.model';

interface OwnProps {
  tabId: string;
}
interface StateProps {
  errors?: NextWorkflowError[];
  shouldDisplayErrorDetails: boolean;
}

export type RejectedStatusProps = OwnProps & StateProps;

function mapToQuoteWorkflowError(error: ProductModificationWorkflowError): NextWorkflowError {
  const { requestId, ...otherProps } = error;
  return {
    ...otherProps,
    rfqId: requestId,
  };
}

const mapStateToProps = (state: AppState, { tabId }: OwnProps): StateProps => {
  const isInternal = getIsUserInternal(state);
  const errors = ProductModificationSelectors.getFormQuoteRejections(state, tabId)?.map(mapToQuoteWorkflowError);
  return {
    errors,
    shouldDisplayErrorDetails: isInternal,
  };
};

export const connectRejectedStatus = connect(mapStateToProps);
